import { PureComponent, ComponentProps, SyntheticEvent } from 'react';

import CopyableTextFieldStateless from './copyable-text-field-stateless';

type CopyableTextFieldProps = ComponentProps<
  typeof CopyableTextFieldStateless
> & {
  initialValue?: string;
  onCopy: (text: string) => void;
  onChange: (e: SyntheticEvent<HTMLInputElement>) => void;
};

type CopyableTextFieldState = {
  value?: string;
};

// eslint-disable-next-line import/no-default-export
export default class CopyableTextField extends PureComponent<
  CopyableTextFieldProps,
  CopyableTextFieldState
> {
  textField: HTMLInputElement | undefined;

  static defaultProps = {
    /* eslint react/default-props-match-prop-types:warn */
    onChange: () => {},
    onCopy: () => {},
  };

  state = {
    value: this.props.initialValue,
  };

  focus() {
    if (this.textField) {
      this.textField.focus();
    }
  }

  select() {
    if (this.textField) {
      this.textField.select();
    }
  }

  handleTextFieldRef = (textField: HTMLInputElement) => {
    this.textField = textField;
  };

  handleOnChange = (e: SyntheticEvent<HTMLInputElement>) => {
    if (e.target instanceof HTMLInputElement) {
      this.setState({ value: e.target.value });
    }

    this.props.onChange(e);
  };

  render() {
    const { onCopy, ...otherProps } = this.props;
    return (
      // @ts-ignore
      <CopyableTextFieldStateless
        {...otherProps}
        onChange={this.handleOnChange}
        onCopy={onCopy}
        forwardedRef={this.handleTextFieldRef}
        value={this.state.value}
      />
    );
  }
}
